<template>
  <v-container id="login">
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-img min-height="100" src="@/assets/image/Nekologic.png">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <br />
          <v-card color="secondary" elevation="24">
            <v-container>
              <h1
                style="
                  color: yellow;
                  font-weight: bold;
                  margin: 20px;
                  text-align: center;
                "
              >
                FORGOT PASSWORD
              </h1>
              <b-alert show :variant="status.type" v-if="status"
                >{{ status.message }}
              </b-alert>
              <h4 style="color: yellow; font-weight: bold; margin: 20px">
                Email Address
              </h4>
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                placeholder="Enter your Email Address"
                type="text"
                background-color="white"
                color="red"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
                solo
              >
                <v-icon slot="prepend" color="yellow">mdi-email</v-icon>
              </v-text-field>
              <br />
              <v-row align="center" justify="space-around">
                <v-btn type="submit" tile class="ml-8" large color="yellow"
                  >Submit
                </v-btn>
                <v-btn tile large color="primary" @click="login"
                  >Back to Login
                </v-btn>
              </v-row>
              <br />
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <br />
    </v-form>
  </v-container>
</template>
<script>
import {mapActions} from "vuex";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    email: {required},
  },
  data() {
    return {
      status: "",
      username: "",
      email: "",
    };
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (this.$v.email.$dirty) {
        !this.$v.email.required && errors.push("Email is required");
      }
      return errors;
    },
  },
  mounted() {
    this.status = "";
  },
  methods: {
    ...mapActions([
      "FORGOT_PASSWORD_REQUEST",
      "showLoadingProcess",
      "closeLoading",
    ]),
    onSubmit() {
      this.$v.$touch();
      /* Checks if form is valid then make api request. */
      if (!this.$v.$invalid) {
        this.forgotPassword();
      }
    },
    async forgotPassword() {
      await this.showLoadingProcess();
      this.FORGOT_PASSWORD_REQUEST(this.email)
        .then(() => {
          this.status = {
            type: "success",
            message:
              "OTP token and reset password link sent to your registered email address.",
          };
          this.closeLoading();
        })
        .catch((err) => {
          this.closeLoading();
          if (err.message === "Network Error") {
            this.status = {
              type: "danger",
              message: "Network Connection Error ",
            };
          } else {
            const res = err.response.data;
            if (res.email !== undefined) {
              this.status = {
                type: "danger",
                message: "E-mail Address not Registered",
              };
            } else if (res.non_field_errors !== undefined) {
              this.status = {
                type: "danger",
                message: "E-mail Address not Registered",
              };
            } else {
              this.status = {
                type: "danger",
                message: "Please try again later!!!",
              };
            }
          }
        });
    },
    login() {
      this.$router.push("/login");
    },
  },
};
</script>
